import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5875d1eb"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "develop-summary-background",
  style: {"padding-top":"25px"}
}
const _hoisted_2 = { class: "container maxWidth-sm text-big" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = {
  class: "col-sm-8 col-sm-offset-2 text-center",
  style: {"margin-top":"20px"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "You are developing", -1))
const _hoisted_6 = {
  "data-test": "develop-page-title",
  class: "current-strength-heading h-underline-info"
}
const _hoisted_7 = { class: "col-sm-2 col-xs-pull-4 col-sm-pull-0 text-right" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "glyphicon glyphicon-transfer" }, null, -1))
const _hoisted_9 = {
  key: 0,
  class: "col-sm-6 col-sm-offset-3",
  style: {"margin-top":"20px"}
}
const _hoisted_10 = { class: "panel tile-shadow panel-default text-center" }
const _hoisted_11 = { class: "panel-body" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { style: {"margin-bottom":"20px"} }, "My Reviews", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { style: {"padding":"0px"} }, null, -1))
const _hoisted_14 = { style: {"padding-top":"20px"} }
const _hoisted_15 = { class: "container maxWidth-sm text-big" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { style: {"padding":"0px"} }, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "h-underline-default",
  style: {"position":"relative","top":"4px"}
}, " Be Your Own Best Coach ", -1))
const _hoisted_19 = { class: "container maxWidth-md text-big" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = {
  key: 0,
  class: "col-sm-12",
  style: {"margin-top":"20px"}
}

import { debug as d } from "debug";
import axios from "axios";
import scrollIntoViewIfNeededPony from "scroll-into-view-if-needed";
import { computed, getCurrentInstance, onBeforeMount, ref } from "vue";
import DevelopProgress from "../components/develop-progress.vue";
import { CmsResourcePlaylist } from "../services/cms/cms-type-definitions";
import cms from "../services/cms/cms";
import { DevelopStrengthProgressApiModel, ProfileApiModel } from "../api-models";
import ResourceThemesList from "../components/cms/resource-themes-list.vue";
import DevelopPlanWeek from "../components/develop/develop-plan-week.vue";
import cmsContentMap from "../services/cms/cms-content-map";
import { DevelopPlan } from "../services/cms/develop-plan";
import { getPlanWeeks, PlanWeekModel } from "../components/develop/develop-plan-models";


export default /*#__PURE__*/_defineComponent({
  __name: 'develop-summary-page',
  setup(__props) {

const debug = d("cs.DevelopSummaryPage");

const profile = ref<ProfileApiModel | null>(null);
const currentPlan = ref<DevelopPlan | null>(null);
const selectedWeekIndex = ref<number | null>(null);
const beYourOwnBestCoachPlaylist = ref<CmsResourcePlaylist | null>(null);

const developSummaryPage = ref<HTMLElement | null>(null);

const currentProgress = computed(() => {
  return profile.value?.developProgress?.currentStrengthProgress;
});

const hasCompletedFirstSelfReview = computed(() => {
  return !!currentProgress.value && typeof currentProgress.value.week1Score === "number";
});

const currentPlanWeeks = computed(() => {
  return !!currentPlan.value && !!currentProgress.value
    ? getPlanWeeks(cms, currentPlan.value, currentProgress.value)
    : null;
});

const weeksExpanded = computed(() => {
  return currentPlanWeeks.value
    ? currentPlanWeeks.value.map((w, i) => i === selectedWeekIndex.value)
    : null;
});

function handleWeekClick(weekIndex: number, shouldExpand: boolean): void {
  debug("handleWeekClick", weekIndex, shouldExpand);
  selectedWeekIndex.value = shouldExpand ? weekIndex : null;
}

function scrollToCurrentDay(): void {
  debug("scrollToCurrentDay");
  const instance = getCurrentInstance()?.proxy as any;

  // get element with class .develop-step.current
  const day = document.querySelector(".develop-step.current");

  // const day = instance?.$el.querySelector(".develop-step.current");
  if (!day) {
    debug("Can't scroll: No current day found");
    return;
  }

  const pageContentElement = day.closest("body");
  if (!pageContentElement) {
    debug("Can't scroll: No page content element found");
    return;
  }
  debug("Scrolling into view if needed");
  scrollIntoViewIfNeededPony(day, {});
}

onBeforeMount(async () => {
  debug("beforeMount");
  const profileResponse = await axios.get("/api/profile");
  if (!profileResponse.data.developProgress) {
    window.location.href = "/session";
    return;
  }
  profile.value = profileResponse.data;

  if (profile.value?.developProgress?.currentStrengthProgress) {
    const plans = await cms.getDevelopPlans();
    const planMap: { [strengthItemId: string]: DevelopPlan } = plans.reduce((obj, plan) => {
      obj[plan.strengthItemId] = plan;
      return obj;
    }, {});
    currentPlan.value =
      planMap[profile.value.developProgress.currentStrengthProgress.strengthItemId];
  } else {
    currentPlan.value = null;
  }

  beYourOwnBestCoachPlaylist.value = await cms.getByUid(
    "cms-resource-playlist",
    cmsContentMap.develop.beYourOwnBestCoachPlaylistUid,
  );
  setTimeout(() => {
    if (currentPlanWeeks.value) {
      selectedWeekIndex.value = currentPlanWeeks.value.findIndex((w) =>
        w.steps.some((s) => s.isCurrent),
      );

      setTimeout(() => {
        scrollToCurrentDay();
      }, 500);
    }
  }, 100);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "develop-summary-page",
    ref_key: "developSummaryPage",
    ref: developSummaryPage
  }, [
    (!!profile.value)
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("h1", _hoisted_6, _toDisplayString(currentProgress.value.strengthItemDisplayTitle), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  "data-test": "change-strength-button",
                  class: "btn btn-default btn-md",
                  style: {"margin":"10px 0"},
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/resources/playlists/the-34-strengths')))
                }, [
                  _hoisted_8,
                  _createTextVNode(" Change Strength ")
                ])
              ]),
              (hasCompletedFirstSelfReview.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _hoisted_12,
                        _createVNode(DevelopProgress, {
                          model: profile.value.developProgress
                        }, null, 8, ["model"])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_13,
    _createElementVNode("section", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentPlanWeeks.value, (week, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: week.id,
              class: "col-sm-12"
            }, [
              _createVNode(DevelopPlanWeek, {
                model: week,
                expanded: weeksExpanded.value[index],
                onExpand: ($event: any) => (handleWeekClick(index, true)),
                onContract: ($event: any) => (handleWeekClick(index, false))
              }, null, 8, ["model", "expanded", "onExpand", "onContract"])
            ]))
          }), 128))
        ])
      ])
    ]),
    _hoisted_17,
    _createElementVNode("section", null, [
      (!!beYourOwnBestCoachPlaylist.value)
        ? (_openBlock(), _createBlock(ResourceThemesList, {
            key: 0,
            doc: beYourOwnBestCoachPlaylist.value,
            "tile-css-class": "tile-shadow",
            "css-theme": ""
          }, {
            title: _withCtx(() => [
              _hoisted_18
            ]),
            _: 1
          }, 8, ["doc"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          (!!beYourOwnBestCoachPlaylist.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 512))
}
}

})